import { render, staticRenderFns } from "./EditPostMenuList.vue?vue&type=template&id=78f5c4e1&scoped=true"
import script from "./EditPostMenuList.vue?vue&type=script&lang=js"
export * from "./EditPostMenuList.vue?vue&type=script&lang=js"
import style0 from "./EditPostMenuList.vue?vue&type=style&index=0&id=78f5c4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5c4e1",
  null
  
)

export default component.exports